module.exports = __webpack_public_path__ + "assets/img/49077f4f45b049efcb6496122c741e64.png";